<template>
    <div class="borderModal">
        <!-- 关闭按钮 -->
        <img class="closed" v-if="!showRewardModal" @click="closeModal" src="../../../assets/imgs/public/close.png" alt="关闭" />

        <!-- 排行榜主体容器 -->
        <div class="rank-card" v-if="!showRewardModal">
            <!-- 顶部 Tab 切换 -->
            <div class="tab-header">
                <div class="tab-item" :class="{ active: currentTab === 'lover' }" @click="currentTab = 'lover'">
                    情侣排行榜
                </div>
                <div class="tab-item" :class="{ active: currentTab === 'bestie' }" @click="currentTab = 'bestie'">
                    闺蜜排行榜
                </div>
            </div>

            <!-- 表头 -->
            <div class="table-header">
                <span class="col-rank">名次</span>
                <span class="col-name">昵称</span>
                <span class="col-score">
                    {{ currentTab === 'lover' ? '累计情侣红心' : '累计蜜糖之心' }}
                </span>
            </div>

            <!-- 列表内容区 -->
            <div class="table-body">
                <div class="table-row" v-for="(item, index) in currentList" :key="index">
                    <span class="col-rank">{{ item.rank }}</span>
                    <span class="col-name" :title="item.name">
                        {{ item.firstUsernick }} --- {{ item.secondUsernick }}
                    </span>
                    <span class="col-score">{{ item.totalHeart }}</span>
                </div>

                <div class="empty-text" v-if="!currentList || currentList.length === 0">
                    暂无排名数据
                </div>
            </div>

            <!-- 底部排行奖励按钮 -->
            <div class="reward-btn-wrap">
                <button class="reward-btn" @click="showRewardModal = true">排行奖励</button>
            </div>
        </div>

        <!-- 嵌套弹出：排行奖励弹窗 -->
        <RewardModal v-if="showRewardModal" @close="showRewardModal = false" />
    </div>
</template>

<script>
import axios from "axios";
import Cookies from "js-cookie";
import RewardModal from "./RewardModal.vue";

export default {
    name: "Ranking",
    components: {
        RewardModal
    },
    data() {
        return {
            currentTab: 'lover',
            showRewardModal: false, // 控制奖励弹窗显示/隐藏
            infoData: {}
        };
    },
    mounted() {
        this.RankingFun();
    },
    computed: {
        currentList() {
            if (this.currentTab === 'lover') {
                return (this.infoData.coupleRank && this.infoData.coupleRank.rankList) || [];
            } else {
                return (this.infoData.sisterRank && this.infoData.sisterRank.rankList) || [];
            }
        }
    },
    methods: {
        closeModal() {
            this.$emit("closeModal");
        },
        RankingFun() {
            axios({
                method: "post",
                url: "/activityV2/getHeartRank",
                headers: {
                    token: Cookies.get("wx_token"),
                },
                data: {
                    userId: Cookies.get("wx_userId"),
                    platForm: "web",
                },
            })
                .then((res) => {
                    if (res.data.state == 200) {
                        this.infoData = res.data.data;
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message);
                });
        }
    }
};
</script>

<style lang="less" scoped>
.borderModal {
    position: relative;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 500px;

    .closed {
        position: absolute;
        top: -30px;
        right: 30px;
        width: 70px;
        height: 70px;
        cursor: pointer;
        z-index: 10;
    }

    .rank-card {
        position: relative;
        width: 500px;
        height: 700px;
        background-image: url('../../../assets/imgs/Qixi/Raningbg.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        padding: 25px 20px 60px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;

        .tab-header {
            display: flex;
            justify-content: space-around;
            margin-top: 8px;
            margin-bottom: 14px;

            .tab-item {
                font-size: 14px;
                font-weight: bold;
                color: rgba(255, 255, 255, 0.65);
                cursor: pointer;
                padding: 2px 6px;
                transition: all 0.2s;

                &.active {
                    color: #ffffff;
                    text-shadow: 0 0 8px rgba(255, 255, 255, 0.9);
                }
            }
        }

        .table-header {
            display: flex;
            align-items: center;
            font-size: 12px;
            color: #ffffff;
            padding-bottom: 8px;
            border-bottom: 1px solid rgba(255, 255, 255, 0.25);

            .col-rank { width: 22%; text-align: center; }
            .col-name { width: 46%; text-align: center; }
            .col-score { width: 32%; text-align: center; }
        }

        .table-body {
            flex: 1;
            overflow-y: auto;
            margin-top: 6px;

            &::-webkit-scrollbar {
                display: none;
            }

            .table-row {
                display: flex;
                align-items: center;
                font-size: 13px;
                color: #ffffff;
                padding: 16px 0;

                .col-rank {
                    width: 22%;
                    text-align: center;
                    font-weight: bold;
                }

                .col-name {
                    width: 46%;
                    text-align: center;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .col-score {
                    width: 32%;
                    text-align: center;
                    font-weight: 500;
                }
            }

            .empty-text {
                font-size: 12px;
                color: rgba(255, 255, 255, 0.6);
                margin-top: 50px;
            }
        }

        .reward-btn-wrap {
            position: absolute;
            bottom:57px;
            left: 0;
            width: 100%;
            display: flex;
            justify-content: center;

            .reward-btn {
                width: 110px;
                height: 32px;
                background: linear-gradient(180deg, #df7eff 0%, #8728df 100%);
                border: 1.5px solid #ffffff;
                border-radius: 16px;
                color: #ffffff;
                font-size: 13px;
                font-weight: bold;
                cursor: pointer;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
                transition: transform 0.1s;

                &:active {
                    transform: scale(0.95);
                }
            }
        }
    }
}
</style>